import {Component, OnInit} from '@angular/core';
import {LeagueType} from '@api/models/league/league-type';
import {formatDate} from '@angular/common';
import {UrlService} from '@utils/services/url/url.service';
import {ISponsor} from '@api/models/sponsor/sponsor';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {MatchService} from '../../services/match/match.service';
import {BettingGamesHttpService} from "@api/http/betting-games/betting-games-http.service";
import {IBettingGame} from "@api/models/betting-game/betting-game";
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {EnvironmentService, EnvironmentType} from '@utils/services/environment/environment.service';

interface IMatchInfo {
  visible: boolean;
  text: string;
  icon: string;
  subText?: string;
  title: string;
  link?: string;
}

@Component({
  selector: 'lib-match-overview',
  templateUrl: './match-overview.component.html',
  styleUrls: ['./match-overview.component.scss']
})
export class MatchOverviewComponent implements OnInit {

  public matchInfos: IMatchInfo[];
  public sponsors: ISponsor[] = [];
  public environmentType: EnvironmentType;

  constructor( public matchService: MatchService,
               private adCampaignService: AdCampaignService) { }

  public ngOnInit(): void {
    this.setMatchInfoData();
    this.setSponsors();
    this.adCampaignService.setPlacement(AdCampaignPlacement.Infos);
  }

  private setSponsors(): void {
    const team = this.matchService.selectedTeam;
    if (team?.sponsors?.length > 0) {
      this.sponsors.push(...team.sponsors);
    }
    if (team?.sponsor) {
      this.sponsors.push(team.sponsor);
    }
  }

  private setMatchInfoData(): void {
    const match = this.matchService.match;
    const leagueName = match.league_info ? match.league_info.league_name : match.league_name;
    let matchLink = null;
    if (match.league_info.league_type !== LeagueType.Friendly) {
      matchLink = UrlService.getSubdomainUrl(match.league_info.league_readable_id);
    }

    // Samstag, 23.10.21 | 14:30
    const startDate = formatDate(match.timestamps.start, 'EEEE, dd.MM.yy, HH:mm', 'de-de') + ' Uhr';
    // startDate = startDate + ' | ' + match.formattedTime;
    const referee = this.getRefereeName(match.referee);
    this.matchInfos = [
      {
        title: 'Bewerb',
        visible: true,
        text: leagueName,
        icon: 'emoji_events',
        subText: match.round?.ui_name || '',
        link: matchLink,
      },
      {
        title: 'Anpfiff',
        visible: true,
        text: startDate,
        icon: 'sports',
      },
      {
        title: 'Stadion',
        visible: !!match.stadium?.name,
        text: match.stadium?.name,
        icon: 'stadium',
      },
      {
        title: 'Schiedsrichter',
        visible: !!referee,
        text: referee,
        icon: 'emoji_people',
      },
      {
        title: 'Zuschauer',
        visible: !!match.spectators,
        text: match.spectators?.toString(),
        icon: 'people_outline',
      },
    ];
  }

  private getRefereeName(referee: any): string {
    if (!referee || (!referee.firstname && !referee.lastname)) {
      return null;
    }
    let name = '';
    if (referee.firstname) {
      name += referee.firstname + ' ';
    }
    if (referee.lastname) {
      name += referee.lastname;
    }
    return name;
  }

  public get showBettingGame(): boolean {
    return !this.matchService.match.isPast()
  }

  public get colorScheme(): ColorScheme {
    return EnvironmentType.website ? ColorScheme.Dark : ColorScheme.Light;
  }
}
